import { TestCase } from '../IntentedComponents';

const increment = n => n + 1;

increment.toString = () => 'n => n+1';

const ImpStateQueue = () => {
  return (
    <>
      <TestCase baseState={0} queue={[1, 1, 1]} expected={1} />
      <hr />
      <TestCase
        baseState={0}
        queue={[increment, increment, increment]}
        expected={3}
      />
      <hr />
      <TestCase baseState={0} queue={[5, increment]} expected={6} />
      <hr />
      <TestCase baseState={0} queue={[5, increment, 42]} expected={42} />
    </>
  );
};

export default ImpStateQueue;
